import { multiply, createUseStyles, add } from '@pushpay/styles';
import { GivingOldTheme } from '@pushpay/theming';
export const logoSize = '24px';
export const headerPadding = '16px';
const headerHoverColor = 'rgba(255, 255, 255, 0.25)';
const headerFocusColor = 'rgba(255, 255, 255, 0.4)';
const useStyles = createUseStyles(theme => {
  const isGivingOld = GivingOldTheme.colors['product-color'] === theme.colors['product-color']; // back compatibility for giving old(red)

  const transitionDuration = 0.3;

  const openTransition = name => `${name} ${transitionDuration}s cubic-bezier(0.7, 0.3, 0.1, 1)`;

  const closeTransition = name => `${name} ${transitionDuration}s ease-out`;

  const orgItemHeight = '60px';
  return {
    root: {
      display: 'inline-flex',
      alignItems: 'center'
    },
    orgOverlayWrapper: {
      height: `calc(100% - ${orgItemHeight})`,
      backgroundColor: theme.colors['color-background-surface']
    },
    overlay: {
      padding: `${headerPadding} 0`,
      minWidth: '212px',
      right: 0,
      left: 'auto'
    },
    overlayHeader: {
      color: theme.colors['color-text-heading'],
      font: theme.TYPOGRAPHY.HEADLINE_4,
      margin: `0 ${headerPadding} ${headerPadding} ${headerPadding}`,
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        margin: 0
      }
    },
    options: {
      overflowY: 'auto',
      [theme.mediaBreakpoint('DESKTOP_AND_ABOVE')]: {
        maxHeight: '220px'
      },
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        maxHeight: '100%',
        paddingBottom: headerPadding
      }
    },
    orgLine: {
      display: 'flex',
      alignItems: 'center',
      padding: `${theme.SPACING.GUTTER} ${headerPadding} `,
      width: '100%',
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        padding: `${headerPadding} ${multiply(headerPadding, 2)} `
      }
    },
    orgItemMobile: {
      paddingLeft: headerPadding,
      paddingRight: headerPadding,
      height: orgItemHeight,
      width: '100%',
      justifyContent: 'flex-start'
    },
    selectOrganization: {
      '&:hover, &:focus': {
        color: theme.colors['palette-white'],
        backgroundColor: theme.colors['palette-grey-dark-200']
      }
    },
    orgLink: {
      display: 'block',
      textDecoration: 'none',
      color: theme.colors['color-text-default'],
      '&:hover, &:focus': {
        color: theme.colors['color-text-default'],
        backgroundColor: theme.colors['palette-grey-light-300'],
        textDecoration: 'none'
      }
    },
    currentOrgLink: {
      backgroundColor: theme.colors['palette-grey-light-300']
    },
    notSelectedOrg: {
      pointerEvents: 'none'
    },
    orgLogo: {
      width: logoSize,
      height: logoSize,
      marginRight: add(theme.SPACING.XSMALL, theme.SPACING.XXSMALL),
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        width: '32px',
        height: '32px'
      }
    },
    orgName: {
      minWidth: '100px',
      maxWidth: '250px',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        maxWidth: '100%'
      }
    },
    orgSummary: {},
    orgSummaryOld: {
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        flex: '1 1 auto',
        display: 'flex',
        justifyContent: 'flex-end'
      }
    },
    orgLabel: {
      font: theme.TYPOGRAPHY.BODY_1,
      display: 'block',
      maxWidth: '50vw',
      padding: `${theme.SPACING.GUTTER} 0`,
      textAlign: 'right',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    orgButton: {
      padding: `0 ${theme.SPACING.XXSMALL} 0 ${theme.SPACING.SMALL}`,
      borderRadius: isGivingOld ? '500px' : theme.SHAPE.ROUNDED_CORNERS,
      height: '40px',
      '&:hover': {
        backgroundColor: isGivingOld ? headerHoverColor : theme.colors['palette-grey-light-300']
      },
      '&:focus': {
        backgroundColor: isGivingOld ? headerFocusColor : theme.colors['palette-grey-light-300']
      },
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        padding: `0 ${theme.SPACING.SMALL}`
      }
    },
    overLayMobile: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: theme.colors['color-background-surface'],
      transition: `${closeTransition('transform')}`,
      transform: 'translateX(100%)'
    },
    orgSwitcherMobileCurrent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '100%',
      '&:hover, &:focus': {
        color: theme.colors['palette-white'],
        backgroundColor: theme.colors['palette-grey-dark-200']
      }
    },
    showOverLayMobile: {
      transform: 'translateX(0)',
      transition: `${openTransition('transform')}`
    },
    orgItemIcon: {
      marginLeft: 'auto',
      display: 'flex'
    },
    orgSwitcherBackIcon: {
      marginRight: add(theme.SPACING.MEDIUM, theme.SPACING.XXSMALL)
    }
  };
});
export default useStyles;